import React from 'react';

const Logo = ({ size = "default" }: { size?: "small" | "default" | "large" | "xlarge" | "xxlarge" }) => {
  const dimensions = {
    small: "h-12 w-12",
    default: "h-16 w-16",
    large: "h-20 w-20",
    xlarge: "h-32 w-32",
    xxlarge: "h-40 w-40"
  };

  return (
    <div className={`${dimensions[size]} relative overflow-hidden flex items-center justify-center`}>
      <img 
        src="/social/Logo.png" 
        alt="VibeBops Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default Logo;
